import { actions as formActions } from "components/advertising/logic/formActions";
import { actions as loginActions } from "components/login/logic/actions";
import { getUserPrivileges } from "components/login/logic/sagas";
import { getPreferences } from "components/settings/user/common";
import { createError } from "core/exceptions";
import { createSagasForBasicCall } from "core/sagas";
import * as log from "loglevel";
import { all, call, put, takeLatest } from "redux-saga/effects";
import AdvertisingService from "services/advertisingService";
import ContactService from "services/contactService";
import { API_URL } from "services/index";
import UserService from "services/userService";
import { actions } from "./actions";
import { isReadOnlyRole } from "../../login/logic/sagas";
export function updateUsers(data) {
    const users = data
        ? data
            .filter((u) => !!u.active)
            .map((u) => ({
                ...u,
                name: `${u.firstName} ${u.lastName}`,
            }))
        : [];
    log.debug(users);
    return users.sort((a, b) => {
        if (a.firstName < b.firstName) {
            return -1;
        }
        if (a.firstName > b.firstName) {
            return 1;
        }
        return 0;
    });
}

export function* setUserInfo(userInfo) {
    const preferences = getPreferences(userInfo);
    const userInfoTransform = {
        ...userInfo,
        privileges: getUserPrivileges(userInfo),
        preferences,
        avatarColor: preferences ? preferences.avatarColor : null,
        avatarText: preferences ? preferences.avatarText : null,
    };
    try {
        yield put(loginActions.INFO_USER.success(userInfoTransform));
    } catch (error) {
        log.error(error);
    }
}
export function* onLoadsStaticData() {
    try {
        const infoUser = yield call(UserService.getUserInfo);
        const isReadOnly = isReadOnlyRole(infoUser);
        const [
            reviewStatusTypes,
            filmRatingTypes,
            advertisementTypes,
            filmCodeTypes,
            users,
            tagData,
            userInfo,
            contactRoles,
        ] = yield all([
            call(AdvertisingService.getNomenclator, API_URL.advertisingRST()),
            call(AdvertisingService.getNomenclator, API_URL.filmRatingT()),
            call(AdvertisingService.getNomenclator, API_URL.advertisingAdvT()),
            call(AdvertisingService.getNomenclator, API_URL.filmCodeT()),
            !isReadOnly ? call(UserService.getUsers) : [],
            call(AdvertisingService.getTags),
            call(UserService.getUserInfo),
            call(ContactService.getContactRoles),
        ]);
        const userData = updateUsers(users);
        if (userInfo) {
            yield call(setUserInfo, userInfo);
            if (userInfo.settings["data.search.advertisement.types"]) {
                const advTypes = advertisementTypes.data;
                const ids = userInfo.settings["data.search.advertisement.types"].split(",");
                const res = [];
                log.debug(advTypes);
                log.debug(ids);
                for (let i = 0; i < ids.length; i++) {
                    const element = advTypes.find((type) => type.id === parseInt(ids[i]));
                    res.push({ value: element.id, label: element.name });
                }
                log.debug(res);

                yield put(formActions.CHANGE_FORM.send({ attribute: "advType", value: res }));
                yield put(formActions.SET_DEFAULT_ADV_TYPES.call(res));
            }
        }
        yield put(
            actions.ON_LOAD_DATA_APP.success({
                reviewStatusTypes: reviewStatusTypes.data,
                filmRatingTypes: filmRatingTypes.data,
                advertisementTypes: advertisementTypes.data,
                filmCodeTypes: filmCodeTypes.data,
                users: userData,
                tags: tagData.data,
                contactRoles: contactRoles,
                userInfo: userInfo,
            })
        );
    } catch (e) {
        log.error(e);
        yield put(actions.ON_LOAD_DATA_APP.failed(null, createError(e)));
    }
}

export default [...createSagasForBasicCall(actions), takeLatest(actions.ON_LOAD_DATA_APP.sendType, onLoadsStaticData)];
